export const fastFoods: string[] = [
    "Red Rooster",
    "Taco Bell",
    "KFC",
    "Boost Juice",
    "Donut King",
    "Hungry Jacks",
    "Noodle Box",
    "Oporto",
    "Pancake Parlour",
    "Sumo Salad",
    "Zambrero",
    "McDonald's",
    "Jollibee"
];